export const contained = 'contained';
export const text = 'text';

export default [contained, text];
